export default "__VITE_ASSET__CYc81zbl__"